import { render, staticRenderFns } from "./bomList.vue?vue&type=template&id=ffcfb02a&scoped=true&"
import script from "./bomList.vue?vue&type=script&lang=js&"
export * from "./bomList.vue?vue&type=script&lang=js&"
import style0 from "./bomList.vue?vue&type=style&index=0&id=ffcfb02a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcfb02a",
  null
  
)

export default component.exports